module.exports = __webpack_public_path__ + "img/ic-exit.a62266fa.svg";